// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widthclass {
  width: 100%;
}

.widthclass1 {
  width: 140px;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/exams/previous_papers/_customprevious.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AACA;EACE,YAAA;AAEF","sourcesContent":[".widthclass {\n  width: 100%;\n}\n.widthclass1 {\n  width: 140px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
